import { TICKET_STATUS } from '@/pages/Tickets/Tickets.constants';

const PRIORITY_COLORS = {
  P1: '#D32F2F',
  P2: '#FB8C00',
  P3: '#5FAFFF',
  P4: '#66BB6A',
  P5: '#9E9E9E'
};

const RISK_COLORS = ['#FF0000', '#FF8C00', '#FFD700', '#32CD32', '#008000'];

const STATUS_COLORS = {
  [TICKET_STATUS.DRAFT]: 'var(--mui-palette-status-draft)',
  [TICKET_STATUS.NEEDS_REVIEW]: 'var(--mui-palette-status-needs-review)',
  [TICKET_STATUS.OPEN]: 'var(--mui-palette-status-open)',
  [TICKET_STATUS.ACKNOWLEDGED]: 'var(--mui-palette-status-acknowledged)',
  [TICKET_STATUS.COMPLETED]: 'var(--mui-palette-status-completed)',
  [TICKET_STATUS.REMEDIATED]: 'var(--mui-palette-status-remediated)',
  [TICKET_STATUS.AUTO_CLOSED]: 'var(--mui-palette-status-auto-closed)'
};

const CATEGORY_COLORS = [
  '#000000',
  '#051324',
  '#304463',
  '#77869C',
  '#9DA9B9',
  '#E3F2FD'
];

const AGE_COLORS = ['#6DBFC9', '#51C0A3', '#74B868', '#DFAC27', '#FF7C32'];

const CYBERSCORE_COLORS = {
  GOVERN: '#003333',
  IDENTIFY: '#004c4c',
  PROTECT: '#006666',
  DETECT: '#008080',
  RESPOND: '#66B2B2',
  RECOVER: '#b2d8d8'
};

const VMP_SOLID_COLORS = {
  CRITICAL: '#B71C1C',
  HIGH: '#FF6F00',
  MEDIUM: '#FFD600',
  LOW: '#4caf50'
};

const VMP_OUTLINED_FILLED_COLORS = {
  CRITICAL: '#EF9A9A',
  HIGH: '#FFAB91',
  MEDIUM: '#FFE68C',
  LOW: '#A5D6A7'
};

const VMP_VULNERABILITY_COLORS = {
  CRITICAL: '#F44336',
  HIGH: '#F57C00',
  MEDIUM: '#FFC906',
  LOW: '#4CAF50'
};

const OS_COLORS = {
  WINDOWS: '#B39DDB',
  LINUX: '#7E57C2',
  MAC: '#5E35B1',
  OTHER: '#4527A0'
};

const PURPLESCALE_COLORS = [
  '#B39DDB',
  '#7E57C2',
  '#5E35B1',
  '#4527A0',
  '#311B92'
];

const GRAYSCALE_COLORS = [
  '#cccccc',
  '#aaaaaa',
  '#888888',
  '#555555',
  '#333333'
];

const BLUE_SCALE_COLORS = {
  LIGHT: '#2196F3',
  DARK: '#0D47A1'
};

const REPORTS_COLORS = {
  EVENTS: '#026670',
  LOG_EVENTS: '#8BB9BD',
  NETWORK_EVENTS: '#026670',
  CASES: '#7B1FA2',
  INVESTIGATED_CASES: '#EF6C00',
  TICKETS: '#C62828',
  TICKETED_CASES: '#D32F2F'
};

export {
  AGE_COLORS,
  BLUE_SCALE_COLORS,
  CATEGORY_COLORS,
  CYBERSCORE_COLORS,
  GRAYSCALE_COLORS,
  OS_COLORS,
  PRIORITY_COLORS,
  PURPLESCALE_COLORS,
  REPORTS_COLORS,
  RISK_COLORS,
  STATUS_COLORS,
  VMP_OUTLINED_FILLED_COLORS,
  VMP_SOLID_COLORS,
  VMP_VULNERABILITY_COLORS
};
